import { type QuestionWithOrder } from '../providers/new-exam/types';

export function getQuestionOrder(questions: QuestionWithOrder[]) {
  if (questions.length === 0) {
    return { minQuestionOrder: 0, maxQuestionOrder: 0 };
  }

  return questions.reduce(
    (acc, question) => {
      if (question.order < acc.minQuestionOrder) {
        acc.minQuestionOrder = question.order;
      }
      if (question.order > acc.maxQuestionOrder) {
        acc.maxQuestionOrder = question.order;
      }
      return acc;
    },
    { minQuestionOrder: Infinity, maxQuestionOrder: -Infinity },
  );
}
